import { AnnouncementForm } from '../../../AnnouncementForm'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { FormValues } from '../../../AnnouncementForm'
import useMutationCreateAnnouncement from '@/modules/announcement/api/hooks/useMutationCreateAnnouncement'
import { AnnouncementQueryKeys } from '@/modules/announcement/keys'
import { useQueryClient } from '@tanstack/react-query'

export function CreateAnnouncementForm() {
	const queryClient = useQueryClient()
	const navigate = useNavigate()
	const { mutate: createAnnouncement } = useMutationCreateAnnouncement()

	const onSubmit = (values: FormValues) => {
		createAnnouncement(
			{ payload: values },
			{
				onSuccess: () => {
					toast.success('สร้างประกาศสำเร็จ')
					queryClient.resetQueries({
						queryKey: [AnnouncementQueryKeys.getAnnouncement],
					})
					navigate('/operator/home-page')
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return <AnnouncementForm mode="create" onSubmit={onSubmit} />
}
